import React from 'react';
import { User as UserIcon } from 'lucide-react';
import { Task } from '../../types';

interface TaskPeopleProps {
  task: Task;
  showNames?: boolean;
}

export function TaskPeople({ task, showNames = false }: TaskPeopleProps) {
  const people = [
    ...(task.assignee_id && task.assignee_name
      ? [{ id: task.assignee_id, name: task.assignee_name, primary: true }]
      : []),
    ...(task.participants || []).map(participant => ({ ...participant, primary: false })),
  ];

  if (people.length === 0) {
    return (
      <div className="flex items-center gap-1 text-gray-300" title="Sem responsável ou participantes">
        <UserIcon size={13} />
        {showNames && <span className="text-xs">Sem pessoas</span>}
      </div>
    );
  }

  return (
    <div className="flex min-w-0 items-center gap-2" title={people.map(person => `${person.name}${person.primary ? ' (responsável)' : ''}`).join(', ')}>
      <div className="flex -space-x-1.5">
        {people.slice(0, 3).map(person => (
          <div
            key={person.id}
            className={`flex h-6 w-6 items-center justify-center rounded-full border-2 border-white text-[10px] font-semibold text-white ${
              person.primary ? 'bg-primary-500' : 'bg-purple-500'
            }`}
          >
            {person.name.charAt(0).toUpperCase()}
          </div>
        ))}
        {people.length > 3 && (
          <div className="flex h-6 w-6 items-center justify-center rounded-full border-2 border-white bg-gray-500 text-[9px] font-semibold text-white">
            +{people.length - 3}
          </div>
        )}
      </div>
      {showNames && (
        <span className="truncate text-xs text-gray-700">
          {task.assignee_name || `${people.length} participante(s)`}
          {task.participants?.length ? ` +${task.participants.length}` : ''}
        </span>
      )}
    </div>
  );
}
